import { render, staticRenderFns } from "./CategoriaDetail.vue?vue&type=template&id=2ac51240&scoped=true"
import script from "./CategoriaDetail.vue?vue&type=script&lang=js"
export * from "./CategoriaDetail.vue?vue&type=script&lang=js"
import style0 from "./CategoriaDetail.vue?vue&type=style&index=0&id=2ac51240&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac51240",
  null
  
)

export default component.exports